import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./common/home.component";
import { RecentComponent } from "./common/recent.component";
import { NotfoundComponent } from "./common/notfound.component";
import { NgbdYtwin } from "./services/ytwin.component";
import { NgbdLbwin } from "./services/lbwin.component";

@NgModule({
  declarations: [
    AppComponent,
    NotfoundComponent,
    HomeComponent,
    RecentComponent,
    NgbdYtwin,
    NgbdLbwin
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule
  ],
  entryComponents: [NgbdYtwin, NgbdLbwin],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
